import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import PageHeader from 'components/common/general/layouts/PageHeader';
import AddEmployeeForm from 'components/utility/add-employee-form';
import {
  AddEmployeeViaFormPageStore,
  AddEmployeeViaFormPageStoreContext,
  useAddEmployeeViaFormPageStore,
} from 'store/pages/utility/add-employee-via-form/pageStore';
import { useParams } from 'react-router-dom';
import { NarrowPageWrapperStyled } from '../../../globalStyles';

const AddEmployeeFormPageHeader: React.FC = observer(() => {
  const { returnBack } = useAddEmployeeViaFormPageStore();

  return (
    <PageHeader
      title="Add Employee"
      subtitle="Quickly add an employee by completing the form below"
      onRedirect={returnBack}
      spacing="WITH_ACTION_BELOW"
    />
  );
});

const AddEmployeeFormPage: React.FC = () => {
  const { groupId } = useParams<{ groupId: string }>();

  const pageStore = useMemo(
    () =>
      new AddEmployeeViaFormPageStore({
        groupId,
      }),
    [],
  );

  return (
    <AddEmployeeViaFormPageStoreContext.Provider value={pageStore}>
      <NarrowPageWrapperStyled>
        <AddEmployeeFormPageHeader />
        <AddEmployeeForm />
      </NarrowPageWrapperStyled>
    </AddEmployeeViaFormPageStoreContext.Provider>
  );
};

export default AddEmployeeFormPage;
